import { cn } from '@/lib/utils'
import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'
import { FAIcon } from '../fa-icon'
import { HoverCard, HoverCardContent, HoverCardTrigger } from './hover-card'

interface Props extends React.ComponentProps<typeof LabelPrimitive.Root> {
  info?: React.ReactNode
}

function Label({
  children,
  className,

  info,

  ...props
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center gap-2 leading-none text-gray-500 font-semibold select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}

      {!!info && (
        <HoverCard openDelay={0} closeDelay={0} onOpenChange={setIsOpen}>
          <HoverCardTrigger asChild>
            <div>
              <FAIcon
                className="text-primary translate-y-px"
                icon="info-circle"
                type={isOpen ? 'solid' : 'regular'}
              />
            </div>
          </HoverCardTrigger>

          <HoverCardContent className="min-w-[400px] text-gray-600">
            {info}
          </HoverCardContent>
        </HoverCard>
      )}
    </LabelPrimitive.Root>
  )
}

export { Label }
